{
  "el": {
    "button": {
      "actions": {
        "add": "Προσθήκη",
        "cancel": "Ακύρωση",
        "close": "Κλείσιμο",
        "copyEmail": "Αντιγραφή email",
        "create": "Δημιουργία",
        "delete": "Διαγραφή",
        "display": "Εμφάνιση",
        "edit": "Επεξεργασία",
        "hide": "Απόκρυψη",
        "loading": "Φόρτωση...",
        "move": "Μετακίνηση",
        "move_down": "Μετακίνηση κάτω",
        "move_up": "Μετακίνηση πάνω",
        "no": "Όχι",
        "reactivateEmailAddress": "Επανενεργοποίηση διεύθυνσης email",
        "reset": "Επαναφορά",
        "save": "Αποθήκευση",
        "save_changes": "Αποθήκευση αλλαγών",
        "save_message": "Αποθήκευση μηνύματος",
        "saving": "Αποθήκευση...",
        "share": "Κοινοποίηση",
        "startTour": "Έναρξη ξενάγησης",
        "uploadingDocuments": "Ανέβασμα εγγράφων...",
        "yes": "Ναι"
      }
    }
  }
}
